import React from 'react'

import { Navbar, Footer } from '../../../components';
import PremiumArticle from './PremiumArticle';

export default function Premarticle5() {
  return (
    <div className='emas__article1'>
        <Navbar />
        <PremiumArticle article="article5" headerImage="transmissioneg.jpg" reference="https://www.pexels.com/photo/transmission-tower-under-gray-sky-189524/" photographer=" Pok Rie" />
        <Footer />
    </div>
  )
}
